/* eslint-disable no-constant-condition */
import React, { useEffect, useLayoutEffect, useMemo, useCallback } from "react";
import RotaDoDiaMapa from "../components/Mapa/RotaDoDiaMapa";
import RotaDoDiaLayout from "../components/Layout/RotaDoDiaLayout";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "~components/Form/components/Loader";
import { useConfigureFooter } from "~hooks/useHelpers";
import ModalIniciarVisita from "../components/Modal/ModalIniciarVisita";
import { initialPath } from "~misc/paths";
import ListagemMapaeVisitas from "../components/Listagem/ListagemMapaeVisitas";
import useRota from "~fetchs/Roterizacao/useRota";
import useVisita from "~fetchs/Roterizacao/useVisita";
import RotaDoDiaFiltroVisitas from "../components/Filtros/RotaDoDiaFiltroVisitas";
import useRouteFilter from "../hooks/useRouteFilter";
import useDefaultFetch from "~fetchs/useDefaultFetch";
import { useGetRotasDoDia } from "~hooks/useSincronizacao";
import useOnlineStatus from "~hooks/useOnlineStatus";
import LoaderFull from "~components/Form/components/LoaderFull";
import { todasAsDatasDoMes } from "~services/GlobalServices";
import RotaDoDiaRotasConcluidas from "../components/Mapa/RotaDoDiaRotasConcluidas";
import useUsuario from "~fetchs/useUsuario";
import { useRotaDoDiaState } from "../hooks/useRotaDoDiaState";
import { useNavigate } from "react-router-dom";
import useVendedor from "~fetchs/useVendedor";

const RotaDoDia = () => {
  useConfigureFooter({ notDeveloped: false });
  const {
    setOrigin,
    setDestination,
    modalOpen,
    setModalOpen,
    idClient,
    setIdClient,
    isLoading,
    loader,
    setLoading,
    skip,
    setSkip,
    take,
    enabled,
    setEnabled,
  } = useRotaDoDiaState();

  const { usuario } = useUsuario();
  const isOnline = useOnlineStatus();

  const dias = useMemo(() => todasAsDatasDoMes(), []);
  const { filters, setFilters, cleanFilters } = useRouteFilter();
  const { vendedorSelecionado } = useVendedor();

  const { rotas, total, totalRenderizado, coordenadas, rotasCoordenadas, todasRotasVisitadas, rotasCoordenadasAmanha } =
    useRota({ filters, skip, take, vendedorSelecionado });
  useDefaultFetch({
    useGet: useGetRotasDoDia,
    table: "rotas",
    enabled,
    remove: false,
  });
  const { visitarRota, checkin } = useVisita({ idClient, setLoading });
  const visitaAtiva = useMemo(() => {
    if (checkin) {
      return {
        clienteId: checkin.clienteId,
        dataPlanejada: checkin.dataPlanejada,
      };
    }
  }, [checkin]);

  useLayoutEffect(() => {
    setEnabled(true);
  }, [setEnabled]);

  const selectRoute = useCallback(
    (item) => {
      if (item.latitude && item.longitude) {
        if (navigator.geolocation && !usuario?.slugAcessos?.includes("nao-capturar-lat-long")) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setOrigin({ lat: position.coords.latitude, lng: position.coords.longitude });
              setDestination({
                lat: Number.parseFloat(item?.latitude.replace(",", ".")),
                lng: Number.parseFloat(item?.longitude.replace(",", ".")),
              });
            },
            (err) => {
              console.error("Erro ao obter localização: ", err.message);
            },
            {
              enableHighAccuracy: true,
              timeout: 5000,
              maximumAge: 0,
            }
          );
        } else {
          console.error("Geolocalização não é suportada neste navegador.");
        }
      }
    },
    [setOrigin, setDestination, usuario?.slugAcessos]
  );

  useEffect(() => {
    if (coordenadas !== null) {
      selectRoute(coordenadas);
    }
  }, [coordenadas, selectRoute]);

  const loadMoreItems = () => {
    setTimeout(() => {
      setSkip(skip + take);
    }, 1100);
  };

  const visitar = (clienteId) => {
    setIdClient(clienteId);
    setModalOpen(true);
  };

  const closedModal = () => {
    setModalOpen(false);
  };

  const navigate = useNavigate();

  const consultar = () => {
    navigate(`${initialPath}/roteirizacao/consulta/${idClient}`);
  };

  const renderMapaComponent = () => {
    if (todasRotasVisitadas && filters.periodo !== "amanha") {
      return <RotaDoDiaRotasConcluidas />;
    }

    if (filters.periodo === "hoje") {
      return <RotaDoDiaMapa rotasCoordenadas={rotasCoordenadas} />;
    }

    return <RotaDoDiaMapa rotasCoordenadas={rotasCoordenadasAmanha} />;
  };

  return (
    <>
      {loader && (
        <div className="flex items-center justify-center w-full p-8 z-100">
          <LoaderFull />
        </div>
      )}

      {isLoading ? (
        <div>Carregando...</div>
      ) : (
        <RotaDoDiaLayout>
          <RotaDoDiaFiltroVisitas filters={filters} setFilters={setFilters} cleanFilters={cleanFilters} type="mapa" />

          {isOnline && filters.search === "" && (filters.periodo === "hoje" || filters.periodo === "amanha") && (
            <>{renderMapaComponent()}</>
          )}

          <p className="mt-4">
            Exibindo <span className="font-bold">{totalRenderizado}</span> de {total}
          </p>

          <InfiniteScroll
            dataLength={totalRenderizado}
            next={loadMoreItems}
            hasMore={total > totalRenderizado}
            loader={<Loader />}
          >
            {rotas?.length > 0 ? (
              rotas.map((item, index) => (
                <ListagemMapaeVisitas
                  key={index}
                  item={item}
                  type="mapa"
                  dias={dias}
                  visit={false}
                  selectRoute={selectRoute}
                  visitar={visitar}
                  visitaAtiva={visitaAtiva}
                />
              ))
            ) : (
              <div className="flex items-center justify-center">
                <p className="text-2xl font-bold">Nenhum dado encontrado!</p>
              </div>
            )}
          </InfiniteScroll>

          {modalOpen && (
            <ModalIniciarVisita
              isOpen={modalOpen}
              id={idClient}
              onClose={closedModal}
              onConfirm={visitarRota}
              onConsult={consultar}
              onCancel={closedModal}
              mensagem="O que deseja fazer?"
            />
          )}
        </RotaDoDiaLayout>
      )}
    </>
  );
};

export default RotaDoDia;
